import React, { SVGProps } from 'react'

export const SecondDefaultCenterSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="36"
    fill="none"
    preserveAspectRatio="none"
    viewBox="0 0 74 36"
    {...props}
  >
    <path
      fill="#7F7472"
      fillRule="evenodd"
      d="M62.519 34.989c3.266 0 7.822-.04 11.481-.989v1c-3.8.985-8.231 1-11.481 1H0v-1.011h62.519Z"
      clipRule="evenodd"
    />
    <path
      fill="#7F7472"
      d="M27.623 1.212C17.377 1.625 7.286 2.769 0 5V4C7.413 1.73 17.315.626 27.583.213c10.277-.414 20.81-.164 29.208.24 2.44.117 6.015.494 9.352.966C69.467 1.889 72.451 2.483 74 3v1c-1.45-.484-4.664-1.12-7.997-1.591-3.32-.47-6.861-.843-9.26-.958-8.381-.402-18.882-.652-29.12-.24Z"
    />
  </svg>
)
